// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EncuestasArchivadasPage_modalOverlay__UzbGd {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.EncuestasArchivadasPage_modal__8vC2H {
  background: white;
  width: 80%;
  max-width: 600px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.EncuestasArchivadasPage_modalContent__l05Eb {
  background: white;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 50px;
  border-radius: 15px;
  width: 90vh;
  height: 90vw; /* Proporción 16:9 */
  max-height: 90vh;
  overflow-y: auto; /* Permite el scroll vertical */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.EncuestasArchivadasPage_modalHeader__qugHj {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: #f1f1f1;
  border-bottom: 1px solid #ccc;
}

.EncuestasArchivadasPage_closeButton__zD33s {
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
}

.EncuestasArchivadasPage_modalContent__l05Eb {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
  max-height: 90vh;
}

.EncuestasArchivadasPage_modalContent__l05Eb::-webkit-scrollbar {
  width: 10px;
}

.EncuestasArchivadasPage_modalContent__l05Eb::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

.EncuestasArchivadasPage_modalContent__l05Eb::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.EncuestasArchivadasPage_modalFooter__yphOn {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: #f1f1f1;
  border-top: 1px solid #ccc;
}

.EncuestasArchivadasPage_containerFilaBusqueda__eeQkH {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 300px;
  margin: 0px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.EncuestasArchivadasPage_titulo__pS7B\\+ {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
  margin-left: 10px;
}

.EncuestasArchivadasPage_divTodoEnUnaFila__odNlx {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  margin-left: 10px;
}

.EncuestasArchivadasPage_divCampos__LoAWK {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 0px;
}

.EncuestasArchivadasPage_divCamposItem__pBZc\\+ {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  margin-top: 10px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.EncuestasArchivadasPage_atributo__iRiDR {
  font-size: 0.8rem;
  font-weight: bold;
  text-wrap: wrap;
  text-align: left;
  color: var(--text-color-claro);
}

.EncuestasArchivadasPage_valor__QT6q9 {
  font-size: 0.8rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.EncuestasArchivadasPage_divBotonera__ZtHBK {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 5px;
}

.EncuestasArchivadasPage_circleImage__Ny0I1 {
  width: 100%; /* Ajusta el tamaño según tus necesidades */
  height: 100px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 8px; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
  margin-bottom: 10px;
}
/* EncuestasPage.module.css */
.EncuestasArchivadasPage_containerGrillaUsuarios__GBZmp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

/* EncuestasPage.module.css */
.EncuestasArchivadasPage_containerGrillaUsuarios__GBZmp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.EncuestasArchivadasPage_containerUsuario__Jfqq2 {
  flex: 1 1 100%;
  max-width: 100%;
  margin: 10px 0;
}

/* EncuestasPage.module.css */
.EncuestasArchivadasPage_containerGrillaUsuarios__GBZmp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.EncuestasArchivadasPage_containerUsuario__Jfqq2 {
  flex: 1 1 100%;
  max-width: 100%;
  margin: 10px 0;
}

@media (min-width: 640px) {
  .EncuestasArchivadasPage_containerUsuario__Jfqq2 {
    flex: 1 1 45%;
    max-width: 45%;
  }
}
/* EncuestasPage.module.css */
.EncuestasArchivadasPage_containerGrillaUsuarios__GBZmp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.EncuestasArchivadasPage_containerUsuario__Jfqq2 {
  flex: 1 1 100%;
  max-width: 100%;
  margin: 10px 0;
}

@media (min-width: 640px) {
  .EncuestasArchivadasPage_containerUsuario__Jfqq2 {
    flex: 1 1 45%;
    max-width: 45%;
  }
}

@media (min-width: 1024px) {
  .EncuestasArchivadasPage_containerUsuario__Jfqq2 {
    flex: 1 1 30%;
    max-width: 30%;
  }
}

.EncuestasArchivadasPage_containerUsuario__Jfqq2 {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  margin-top: 10px; /* Agrega un poco de margen entre los botones */
}

@media (min-width: 640px) {
  .EncuestasArchivadasPage_containerFilaBusqueda__eeQkH {
    flex-wrap: nowrap;
  }

  .EncuestasArchivadasPage_containerUsuario__Jfqq2 {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 50%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 58%; /* Asegura que los botones no sean más anchos que el 30% */
  }

  .EncuestasArchivadasPage_divBotonera__ZtHBK {
    width: 70%;
    margin-left: 15px;
  }
}

@media (min-width: 1024px) {
  /* Ajusta este valor según tus necesidades */
  .EncuestasArchivadasPage_containerGrillaUsuarios__GBZmp {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .EncuestasArchivadasPage_containerUsuario__Jfqq2 {
    flex: 1 1 45%;
    max-width: 45%;
  }

  .EncuestasArchivadasPage_circleImage__Ny0I1 {
    width: 30%; /* Ajusta el tamaño según tus necesidades */
    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
    border-radius: 50%; /* Esto crea el círculo */
    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }
}

@media (min-width: 1200px) {
  .EncuestasArchivadasPage_containerUsuario__Jfqq2 {
    flex: 1 1 30%;
    max-width: 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/encuestas/encuestas-archivadas/EncuestasArchivadasPage.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY,EAAE,oBAAoB;EAClC,gBAAgB;EAChB,gBAAgB,EAAE,+BAA+B;EACjD,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB,EAAE,+CAA+C;AACnE;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;EAC5E;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,4CAA4C;EAC5C;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,UAAU,EAAE,2CAA2C;IACvD,YAAY,EAAE,8EAA8E;IAC5F,kBAAkB,EAAE,yBAAyB;IAC7C,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  width: 80%;\n  max-width: 600px;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n}\n\n.modalContent {\n  background: white;\n  padding-left: 20px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-right: 50px;\n  border-radius: 15px;\n  width: 90vh;\n  height: 90vw; /* Proporción 16:9 */\n  max-height: 90vh;\n  overflow-y: auto; /* Permite el scroll vertical */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n  background: #f1f1f1;\n  border-bottom: 1px solid #ccc;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 1.5em;\n  cursor: pointer;\n}\n\n.modalContent {\n  padding: 20px;\n  overflow-y: auto;\n  flex-grow: 1;\n  max-height: 90vh;\n}\n\n.modalContent::-webkit-scrollbar {\n  width: 10px;\n}\n\n.modalContent::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n\n.modalContent::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n  background: #f1f1f1;\n  border-top: 1px solid #ccc;\n}\n\n.containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 300px;\n  margin: 0px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n  margin-left: 10px;\n}\n\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  margin-left: 10px;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 0px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  margin-top: 10px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-wrap: wrap;\n  text-align: left;\n  color: var(--text-color-claro);\n}\n\n.valor {\n  font-size: 0.8rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.circleImage {\n  width: 100%; /* Ajusta el tamaño según tus necesidades */\n  height: 100px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 8px; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n  margin-bottom: 10px;\n}\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  flex: 1 1 100%;\n  max-width: 100%;\n  margin: 10px 0;\n}\n\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  flex: 1 1 100%;\n  max-width: 100%;\n  margin: 10px 0;\n}\n\n@media (min-width: 640px) {\n  .containerUsuario {\n    flex: 1 1 45%;\n    max-width: 45%;\n  }\n}\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  flex: 1 1 100%;\n  max-width: 100%;\n  margin: 10px 0;\n}\n\n@media (min-width: 640px) {\n  .containerUsuario {\n    flex: 1 1 45%;\n    max-width: 45%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .containerUsuario {\n    flex: 1 1 30%;\n    max-width: 30%;\n  }\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n  padding: 10px;\n  margin-top: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n@media (min-width: 640px) {\n  .containerFilaBusqueda {\n    flex-wrap: nowrap;\n  }\n\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 50%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 58%; /* Asegura que los botones no sean más anchos que el 30% */\n  }\n\n  .divBotonera {\n    width: 70%;\n    margin-left: 15px;\n  }\n}\n\n@media (min-width: 1024px) {\n  /* Ajusta este valor según tus necesidades */\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .containerUsuario {\n    flex: 1 1 45%;\n    max-width: 45%;\n  }\n\n  .circleImage {\n    width: 30%; /* Ajusta el tamaño según tus necesidades */\n    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n    border-radius: 50%; /* Esto crea el círculo */\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n}\n\n@media (min-width: 1200px) {\n  .containerUsuario {\n    flex: 1 1 30%;\n    max-width: 30%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `EncuestasArchivadasPage_modalOverlay__UzbGd`,
	"modal": `EncuestasArchivadasPage_modal__8vC2H`,
	"modalContent": `EncuestasArchivadasPage_modalContent__l05Eb`,
	"modalHeader": `EncuestasArchivadasPage_modalHeader__qugHj`,
	"closeButton": `EncuestasArchivadasPage_closeButton__zD33s`,
	"modalFooter": `EncuestasArchivadasPage_modalFooter__yphOn`,
	"containerFilaBusqueda": `EncuestasArchivadasPage_containerFilaBusqueda__eeQkH`,
	"titulo": `EncuestasArchivadasPage_titulo__pS7B+`,
	"divTodoEnUnaFila": `EncuestasArchivadasPage_divTodoEnUnaFila__odNlx`,
	"divCampos": `EncuestasArchivadasPage_divCampos__LoAWK`,
	"divCamposItem": `EncuestasArchivadasPage_divCamposItem__pBZc+`,
	"atributo": `EncuestasArchivadasPage_atributo__iRiDR`,
	"valor": `EncuestasArchivadasPage_valor__QT6q9`,
	"divBotonera": `EncuestasArchivadasPage_divBotonera__ZtHBK`,
	"circleImage": `EncuestasArchivadasPage_circleImage__Ny0I1`,
	"containerGrillaUsuarios": `EncuestasArchivadasPage_containerGrillaUsuarios__GBZmp`,
	"containerUsuario": `EncuestasArchivadasPage_containerUsuario__Jfqq2`
};
export default ___CSS_LOADER_EXPORT___;
